"use strict";

angular.module('PatientApp').controller('MessageDetailsCtrl', function ($scope, $q, $filter, $state, $log, _, ContextHelperService, ProvidersService, BillsService, LoadingIndicatorService, ErrorsService, PatientUsersService, endpoints, VuexStore, VueEventTransmitter) {
  var _loadingKeyPromise;

  _loadingKeyPromise = LoadingIndicatorService.loading();
  VueEventTransmitter.$on('messageDetails:loadingComplete', function () {
    _loadingKeyPromise.then(function (key) {
      LoadingIndicatorService.complete(key);
    });
  });
  VueEventTransmitter.$on('messageDetails:viewBill', function (secureCode) {
    BillsService.openPdf(secureCode);
  });
  VueEventTransmitter.$on('messageDetails:showBreadCrumbs', function () {
    if ($state.previous.name === 'app.messages') {
      ContextHelperService.showBreadCrumbs({
        label: $filter('translate')('actions.backToMessages'),
        onClick: function onClick() {
          $state.go('app.messages');
        }
      });
    }
  });
  VueEventTransmitter.$on('messageDetails:errorHandler', function (resp) {
    var errorNotifications = {};

    switch (ErrorsService.resolve(resp.data || resp)) {
      case ErrorsService.errors.TOO_MANY_FILES:
        errorNotifications.tooManyFiles = true;
        break;

      case ErrorsService.errors.GENERIC_FILE_ERROR:
        errorNotifications.genericFileError = true;
        break;

      case ErrorsService.errors.FILE_TOO_LARGE:
        errorNotifications.fileTooLarge = true;
        break;

      case ErrorsService.errors.INVALID_FILE_TYPE:
        errorNotifications.invalidFileType = true;
        break;

      default:
        errorNotifications.genericFileError = true;
        break;
    }

    VueEventTransmitter.$emit('messageDetails:handledError', errorNotifications);
  });
});